export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9754.72b9ac9b.jpg";